import type { IPlacement } from '~/types/placements'

import config from '~/config'
import { DEFAULT_ITEMS_PER_PAGE_VALUE } from '~/const'
import { request } from '~/utils/request'

export const getPlacements = ({
  appKey,
  key,
  page = 0,
  size = DEFAULT_ITEMS_PER_PAGE_VALUE,
}: {
  appKey?: string
  key?: string
  page?: number
  size?: number
}): Promise<IPaginatedResponse<IPlacement>> => {
  return request({
    params: {
      app_key: appKey,
      key,
      page,
      size,
    },
    url: `${config.DYNAMIC_SCREEN_API}/placements`,
  })
}

export const createPlacement = ({ appKey, key }: { appKey: string; key: string }): Promise<void> => {
  return request({
    data: {
      app_key: appKey,
      key,
    },
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/placements`,
  })
}
